import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72cb31a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "form-wrapper" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "sub-text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, [
  /*#__PURE__*/_createTextVNode(" 全国のNPO番号の検索は"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.npo-homepage.go.jp/about/houjin-info/npo-kensaku",
    target: "_blank"
  }, "こちら"),
  /*#__PURE__*/_createTextVNode("。都内にあるNPO団体のNPO番号検索は"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.seikatubunka.metro.tokyo.lg.jp/houjin/npo_houjin/list/",
    target: "_blank"
  }, "こちら"),
  /*#__PURE__*/_createTextVNode("。 ")
], -1))
const _hoisted_6 = { class: "text-center" }

import { computed, onMounted, ref } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { ColorVariants } from '@/constants';
  import { useRouter } from 'vue-router';
  import { request, alert } from '@/utils';
  import { settingStore } from '@/stores';
  import { FormItemOption } from '@/types/form';
  import _ from 'lodash';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();
  const router = useRouter();
  const isJapan = process.env.VUE_APP_COUNTRY === 'ja';

  const charityOptions = computed<FormItemOption[]>(() => {
    return _.map(settingStore.data.charity_org_type_list, item => ({ value: item, text: item }));
  });

  onMounted(() => {});
  function formatFormData(formData: FormData) {
    const data: { [key: string]: any } = {};
    for (let [key, val] of formData.entries()) {
      if (data[key]) {
        data[key] = [val].concat(data[key]);
      } else {
        data[key] = val;
      }
    }
    return data;
  }

  async function handleSubmit(e: Event) {
    const body = formatFormData(new FormData(e.target as HTMLFormElement));
    const { data } = await request.post('mine/charities', body);
    if (data.npo_number_hint) {
      alert({ title: t('Success'), content: data.npo_number_hint });
    }
    router.push({ name: 'points' });
  }

return (_ctx: any,_cache: any) => {
  const _component_AppBreadcurmb = _resolveComponent("AppBreadcurmb")!
  const _component_AppFormGroupItem = _resolveComponent("AppFormGroupItem")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form = _resolveComponent("b-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppBreadcurmb, {
      routes: [
        {
          name: _unref(t)('Home'),
          to: { name: 'home' }
        },
        {
          name: _unref(t)('TerraCycle Recycling Rewards'),
          to: { name: 'points' }
        },
        {
          name: _unref(t)('New Charity')
        }
      ],
      style: {"margin":"2.3rem 0 2.6rem"}
    }, null, 8, ["routes"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('New Charity')), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('Please fill in all required fields below.')), 1),
      _createVNode(_component_b_form, {
        class: "form",
        onSubmit: handleSubmit
      }, {
        default: _withCtx(() => [
          _createVNode(_component_AppFormGroupItem, {
            key: "name",
            form: ref({}),
            config: {
            label: _unref(t)('Name'),
            type: 'input',
            required: true,
            key: 'name',
          }
          }, null, 8, ["form", "config"]),
          _createVNode(_component_AppFormGroupItem, {
            key: "organization_type",
            form: ref({}),
            config: {
            label: _unref(t)('Organization Type'),
            required: true,
            type: 'select',
            key: 'organization_type',
            options: _unref(charityOptions)
          }
          }, null, 8, ["form", "config"]),
          _createVNode(_component_AppFormGroupItem, {
            key: "address",
            form: ref({}),
            config: {
            label: _unref(t)('Address 1'),
            required: true,
            type: 'input',
            key: 'address',
          }
          }, null, 8, ["form", "config"]),
          _createVNode(_component_AppFormGroupItem, {
            key: "city",
            form: ref({}),
            config: {
            label: _unref(t)('City'),
            required: true,
            type: 'input',
            key: 'city',
          }
          }, null, 8, ["form", "config"]),
          _createVNode(_component_AppFormGroupItem, {
            key: "region",
            form: ref({}),
            config: {
            label: _unref(t)('State'),
            required: true,
            type: 'input',
            key: 'region',
          }
          }, null, 8, ["form", "config"]),
          _createVNode(_component_AppFormGroupItem, {
            key: "postal_code",
            form: ref({}),
            config: {
            label: _unref(t)('Zip code'),
            required: true,
            type: 'input',
            key: 'postal_code',
          }
          }, null, 8, ["form", "config"]),
          _createVNode(_component_AppFormGroupItem, {
            key: "contact_person",
            form: ref({}),
            config: {
            label: _unref(t)('Contact Person'),
            required: true,
            type: 'input',
            key: 'contact_person',
          }
          }, null, 8, ["form", "config"]),
          _createVNode(_component_AppFormGroupItem, {
            key: "contact_phone",
            form: ref({}),
            config: {
            label: _unref(t)('Contact Phone'),
            required: true,
            type: 'input',
            inputType: 'tel',
            key: 'contact_phone',
          }
          }, null, 8, ["form", "config"]),
          _createVNode(_component_AppFormGroupItem, {
            key: "email",
            form: ref({}),
            config: {
            label: _unref(t)('Email Address'),
            type: 'input',
            inputType: 'email',
            key: 'email',
          }
          }, null, 8, ["form", "config"]),
          _createVNode(_component_AppFormGroupItem, {
            key: "tax_id_number",
            form: ref({}),
            config: {
            label: _unref(t)('Federal Tax ID Number'),
            type: 'input',
            key: 'tax_id_number',
          }
          }, null, 8, ["form", "config"]),
          isJapan
            ? (_openBlock(), _createBlock(_component_AppFormGroupItem, {
                key: "npo_number",
                form: ref({}),
                config: {
            label: 'NPO番号',
            type: 'input',
            key: 'npo_number',
          }
              }, {
                inputBefore: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["form"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_b_button, {
              type: "submit",
              pill: "",
              variant: _unref(ColorVariants).primary,
              class: "btn-submit"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('Submit')), 1)
              ]),
              _: 1
            }, 8, ["variant"])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})